export const getMentionDetails = (tweetObjects) => {
    const allMentions = [].concat.apply([], tweetObjects.map((tweetObject) => tweetObject.Tweet.UserMentions.map(um => um.UserName)));
    const filteredMentions = allMentions.filter(mentionsFilter);
    const uniqueMentions = Array.from(new Set(filteredMentions));
    return uniqueMentions.map(uniqueMention => ({
        mention: uniqueMention,
        count: filteredMentions.filter(mention => mention===uniqueMention).length
    }));
}

const mentionsToIgnore = ["realDonaldTrump"];

export const mentionsFilter = (mention) => mentionsToIgnore.filter(toIgnore => toIgnore.toLowerCase() === mention.toLowerCase()).length === 0;
